/* Copyright (c) 2023 MOCA Systems, Inc.  All rights reserved. */

export enum UserPreferenceCategories {
	HoverPrefs = 'hoverPrefs',
	HoverPrefsCustomFields = 'hoverPrefsCustomFields',
	ReportPrefs = 'reportPrefs',
	PlanFilteringTicketPrefs = 'planFilteringTicketPrefs',
	ScheduleDisclaimer = 'scheduleDisclaimer',
	MISC = 'misc',
}

export interface IScheduleDisclaimerData {
	lastUpdatedAt?: string;
	createdAt?: string;
}
